import React from 'react';

type DateInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>;

const DateInput: React.FC<DateInputProps> = ({ onChange, ...props }) => {
  const handleCopy = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value; // ISO: yyyy-mm-dd
    if (value) {
      const [y, m, d] = value.split('-');
      e.preventDefault();
      e.clipboardData.setData('text/plain', `${d}/${m}/${y}`);
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const text = e.clipboardData.getData('text').trim();
    const match = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);

    if (match && onChange) {
      const d = parseInt(match[1], 10);
      const m = parseInt(match[2], 10);
      const y = parseInt(match[3], 10);

      if (m >= 1 && m <= 12 && d >= 1 && d <= 31) {
        const isoDate = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
        const date = new Date(isoDate);
        if (date.getFullYear() === y && date.getMonth() + 1 === m && date.getDate() === d) {
          e.preventDefault();
          const syntheticEvent = {
            target: { name: e.currentTarget.name, value: isoDate },
            currentTarget: { name: e.currentTarget.name, value: isoDate },
          } as React.ChangeEvent<HTMLInputElement>;
          onChange(syntheticEvent);
        }
      }
    }
  };

  return (
    <input
      type="date"
      onCopy={handleCopy}
      onCut={handleCopy}
      onPaste={handlePaste}
      onChange={onChange}
      {...props}
    />
  );
};

export default DateInput;
